module.exports = __webpack_public_path__ + "static/media/parent-icon.ebe348a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/parent-icon.png
// module id = 1799
// module chunks = 0